import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';

import {FluxStoreBoundComponent} from 'rlink-flux';
import telemetry from 'rlink-telemetry';
import {twitchActions} from 'rlink-twitch/actions';
import {TwitchService} from 'rlink-twitch/service';
import {twitchStore} from 'rlink-twitch/store';
import {delayUntilStable} from 'rlink-utils/anim';
import twitchLogo from './assets/twitch_logo.png';
import {ContentImg} from 'rlink-repos/content-components';

class TwitchThumbnail extends Component {
  componentDidMount () {
    telemetry.trackView(`${location.pathname}#${this.telemetryIdentifier()}`);
  }
  telemetryIdentifier () {
    if (this.props.broadcast.live) {
      return `${encodeURI(this.props.broadcast.channel)}/LIVE`;
    } else {
      return `${encodeURI(this.props.broadcast.channel)}/${encodeURI(this.props.broadcast.title || this.props.broadcast.id)}`;
    }
  }
  trackNav () {
    telemetry.trackNav( this.broadcastLink());
  }

  broadcastLink () {
    if (this.props.steamLinks === false) {
      return `https://www.twitch.tv/${this.props.broadcast.channel}`;
    }

    let queryString = 'html5';
    if (!this.props.broadcast.live) {
      queryString += `&video=${this.props.broadcast.id}`;
    } else {
      queryString += `&channel=${this.props.broadcast.channel}`;
    }
    return `http://player.twitch.tv?${queryString}`;
  }

  renderDetails () {
    return <span>
      {this.props.broadcast.live
        ? <span className={this.props.theme['channel-name']}><strong>[LIVE]</strong>{this.props.broadcast.channel}</span>
        : <span className={this.props.theme['channel-name']}>{this.props.broadcast.title}</span>
      }
      <span className={this.props.theme['view-count']}>{this.props.broadcast.views} {this.props.broadcast.live ? 'viewers' : 'views'}</span>
    </span>
  }

  render () {
    let thumbnail = (this.props.thumbnail)
      ? <ContentImg src={this.props.thumbnail} />
      : <img src={this.props.broadcast.previewUrl}
        className={(this.props.broadcast.live) ? this.props.theme['thumbnail-stream'] : this.props.theme['thumbnail-video']}/>;
    return (
      <div className={this.props.theme['twitch-item-wrapper']}>
        <a className={this.props.theme['twitch-item']}
            target={(this.props.steamLinks) ? "" : "_blank"}
          onClick={ev => this.trackNav()}
          href={`${(this.props.steamLinks) ? 'steamBrowser:' : ''}${this.broadcastLink()}`}>

          <div className={this.props.theme['thumbnail-wrapper']}>
            {thumbnail}
          </div>

          {this.props.type === TwitchWidget.renderTypes.FULL && this.renderDetails()}
        </a>
      </div>
    );
  }
}

TwitchThumbnail.propTypes = {
  broadcast: PropTypes.shape({
    id: PropTypes.string.isRequired,
    channel: PropTypes.string.isRequired,
    previewUrl: PropTypes.string.isRequired,
    views: PropTypes.number,
    live: PropTypes.bool,
    title: PropTypes.string,
  }),
  type: PropTypes.string,
};

export default class TwitchWidget extends FluxStoreBoundComponent {
  twitchService () {
    if (!this._twitchService) {
      this._twitchService = new TwitchService(this.props.clientId);
    }
    return this._twitchService;
  }

  _loadBroadcasts () {
    let index = 0;
    this.props.channelGroups.map(channelGroup => {
      let channels = channelGroup.has('whitelistChannels') ? channelGroup.get('whitelistChannels').toJS() : [];
      twitchActions.LoadBroadcasts({
        service: this.twitchService(),
        channels,
        gameFilter: channelGroup.get('gameFilter'),
        maxChildren: channelGroup.get('maxChildren'),
        groupId: index,
      });
      index += 1;
    });

  }

  getStore () {
    return twitchStore;
  }

  getStateFromStore () {
    return {broadcastGroups: this.getStore().getMostActiveBroadcasts(this.props.channelGroups)};
  }

  componentWillMount () {
    this._loadBroadcasts();
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (this.state !== nextState) {
      delayUntilStable('twitchWidgetDelay', 500, () => {
        this.forceUpdate();
      });
    }
    return false;
  }

  componentWillReceiveProps (nextProps) {
    this._loadBroadcasts();
  }

  render () {
    return (
      <div className={this.props.theme['twitch-container']}>
        {(() => {
          let optional = [];
          if (this.props.title) {
            let liveChannelExists = false;
            for (let group of this.state.broadcastGroups) {
              if (group.broadcasts.length > 0) {
                liveChannelExists = true;
                break;
              }
            }

            if (liveChannelExists) {
              optional.push(<h2>{this.props.title}</h2>);
            }
          }

          if (this.props.showLogo) {
            optional.push(<img src={twitchLogo} className={this.props.theme['twitch-logo']}/>);
          }

          return optional;
        })()}
        <div className={this.props.theme['overflow-wrapper']}>
          <div className={this.props.theme['broadcasts']}>
            {
              this.state.broadcastGroups.map((broadcastGroup) => {
                return broadcastGroup.broadcasts.map(broadcast => <TwitchThumbnail
                  key={broadcast.id}
                  type={this.props.type}
                  steamLinks={this.props.steamLinks}
                  broadcast={broadcast}
                  thumbnail={broadcast.thumbnail}
                  theme={this.props.theme} />)
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

TwitchWidget.renderTypes = {
  FULL: 0,
  BARE: 1,
};

TwitchWidget.propTypes = {
  type: PropTypes.number,
  steamLinks: PropTypes.bool,
  showLogo: PropTypes.bool,
};

TwitchWidget.defaultProps = {
  type: TwitchWidget.renderTypes.FULL,
  steamLinks: false,
  showLogo: false,
};



// WEBPACK FOOTER //
// ./lib/rlink-twitch/component.jsx